var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('imgHeader',{attrs:{"imgUrl":"/img/6党团活动-banner.jpg"}}),_c('NewsCom',{attrs:{"title":_vm.$t('public.partyTitle')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }